import { render, staticRenderFns } from "./TechRoadmap.vue?vue&type=template&id=9a5d1a0c&scoped=true&"
import script from "./TechRoadmap.vue?vue&type=script&lang=js&"
export * from "./TechRoadmap.vue?vue&type=script&lang=js&"
import style0 from "./TechRoadmap.vue?vue&type=style&index=0&id=9a5d1a0c&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9a5d1a0c",
  null
  
)

export default component.exports